export const NOTIFICATION_CATEGORIES = ['crm', 'finance', 'project', 'infra', 'hr', 'printer', 'system'] as const
export type NotificationCategory = (typeof NOTIFICATION_CATEGORIES)[number]

export type NotificationLevel = 'info' | 'success' | 'warning' | 'critical'

export type AppNotification = {
  id: string
  category: NotificationCategory
  level: NotificationLevel
  title: string
  body: string
  link: string | null
  actor: string
  createdAt: string
  readAt: string | null
}

export type ReadFilter = 'all' | 'unread' | 'read'
